module.exports = __webpack_public_path__ + "img/qrcode.d176492a.png";